import { Controller } from 'stimulus';

// The template-filter question builder (Settings -> Template Filters).
// High-frequency assignment edits — chip removes and popover checkbox
// toggles — post to toggle_template and swap in the re-rendered question
// card plus the preview drawer, so the page never reloads mid-flow. The
// open popover (and its filter text) is restored after each swap so an
// admin can check several templates in a row. Rename affordances just
// reveal the standard forms; those submit normally.
export default class extends Controller {
  static targets = ['preview'];

  toggle(event) {
    const el = event.currentTarget;
    this.rememberPopover(el);
    fetch(el.dataset.url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': (document.querySelector('meta[name="csrf-token"]') || {}).content,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ template_id: el.dataset.templateId })
    })
      .then(response => (response.ok ? response.json() : Promise.reject(response)))
      .then(json => {
        const card = document.getElementById(el.dataset.card);
        if (card) card.outerHTML = json.card;
        if (this.hasPreviewTarget) this.previewTarget.innerHTML = json.preview;
        this.restorePopover();
      })
      .catch(() => window.location.reload());
  }

  openPopover(event) {
    const pop = document.getElementById(event.currentTarget.dataset.popover);
    if (pop) pop.classList.toggle('hidden');
  }

  closePopover(event) {
    const pop = event.currentTarget.closest('[data-popover-id]');
    if (pop) pop.classList.add('hidden');
  }

  filterPopover(event) {
    const pop = event.currentTarget.closest('[data-popover-id]');
    this.applyFilter(pop, event.currentTarget.value);
  }

  // Reveals the inline rename form next to a question or option label.
  showRename(event) {
    const wrap = event.currentTarget.closest('[data-rename]');
    if (!wrap) return;
    wrap.querySelector('.tb-display').classList.add('hidden');
    const form = wrap.querySelector('.tb-form');
    if (!form) return;
    form.classList.remove('hidden');
    const input = form.querySelector('input[type="text"]');
    if (input) { input.focus(); input.select(); }
  }

  rememberPopover(el) {
    const pop = el.closest('[data-popover-id]');
    this.openPop = pop ? pop.dataset.popoverId : null;
    const filter = pop ? pop.querySelector('input[type="text"]') : null;
    this.popFilter = filter ? filter.value : '';
  }

  restorePopover() {
    if (!this.openPop) return;
    const pop = document.getElementById(this.openPop);
    if (!pop) return;
    pop.classList.remove('hidden');
    const filter = pop.querySelector('input[type="text"]');
    if (filter && this.popFilter) {
      filter.value = this.popFilter;
      this.applyFilter(pop, this.popFilter);
      filter.focus();
    }
  }

  applyFilter(pop, query) {
    if (!pop) return;
    const needle = (query || '').toLowerCase();
    pop.querySelectorAll('label').forEach(label => {
      label.style.display = label.textContent.toLowerCase().indexOf(needle) >= 0 ? '' : 'none';
    });
  }
}
